<template>
  <div>
    <div v-if="orderedSubmissions.length" class="relative px-3">
      <div
        id="recap-card"
        v-if="
          submissionsCount &&
          ((hasTeacherPermissionsInCourse && !genieRecap.id) || genieRecap.id)
        "
        class="mt-4"
      >
        <GenieRecap
          :submissions="submissionsCount"
          @editRecap="edit_recap = true"
          @deleteRecap="delete_recap = true"
          class="pb-5 px-2 border-b border-gray-100"
        />
      </div>
      <div
        v-for="(item, index) in orderedSubmissions"
        :key="item.id"
        class="relative"
      >
        <template v-if="!edit_prompt">
          <template v-if="index < responses.length">
            <SubmissionCard
              class="feed-card relative"
              :class="
                index === responses.length - 1 ? '' : 'border-b border-gray-100'
              "
              :submission="item"
              :id="`feed-${item.id}`"
              ref="card"
              :key="$route.path"
              :hasNext="orderedSubmissions && orderedSubmissions.length > 1"
              @openAssessmentTab="openAssessmentTab(item.id)"
              @showDeleteSubmissionModal="showDeleteSubmissionModal"
              @showHideSubmissionModal="showHideSubmissionModal"
              @openAnonymityModal="openAnonymityModal"
              @showAssessmentModal="showAssessmentModal"
            />
          </template>
          <template v-if="index >= responses.length">
            <div
              v-if="index === responses.length"
              v-bind:key="item.id + 'feed-observers-divider'"
              id="feed-observers-divider"
              class="flex justify-center"
            >
              <div class="flex items-center w-full">
                <div
                  class="col-xs m-auto border-b border-solid border-gray-300 rounded"
                />
                <span class="mx-3 text-sm font-medium text-gray-400">
                  Observers
                </span>
                <div
                  class="col-xs m-auto border-b border-solid border-gray-300 rounded"
                />
              </div>
            </div>
            <div
              :class="
                orderedSubmissions.length - 1 !== index
                  ? 'border-gray-100 border-solid border-b'
                  : ''
              "
            >
              <ByPassCard
                :key="item.id"
                :id="`feed-${item.id}`"
                :submission="item"
                @openAssessmentTab="openAssessmentTab"
              />
            </div>
          </template>
        </template>
      </div>
    </div>
    <div v-else class="checklist-height flex flex-col items-center justify-center">
      <Checklist
        v-if="hasTeacherPermissionsInCourse && !studentsInvited"
        :roundtable="getCurrentRT"
      />
      <div
        v-if="studentsInvited"
        class="h-full flex flex-col w-full relative space-y-16"
      >
        <div class="w-full mt-4">
          <img
            class="w-full"
            src="/static/online_roundtable_icons/blank_submissions.svg"
          />
        </div>
        <div class="flex flex-col ml-8 items-center justify-center text-base">
          <h3 class="text-center font-semibold">
            No Students responses yet...
          </h3>
          <span>Click on student names to view their draft responses.</span>
        </div>
      </div>
    </div>
    <!-- Dialogs -->
    <div v-if="edit_prompt" class="transparent-modal">
      <prompt-in-feed-modal
        v-bind:key="'prompt-in-feed'"
        @toggleEditPrompt="edit_prompt = !edit_prompt"
        :editPrompt="edit_prompt"
        style="overflow-wrap: break-word"
      />
    </div>
    <!-- Confirmation modal for delete submission -->
    <div>
      <dialog-delete-confirm
        v-if="show_delete_submission_modal"
        @close="show_delete_submission_modal = false"
        @actionConfirmed="deleteSubmission"
        optionalText="Delete Submission"
        :subHeader="
          'Are you sure you want to delete ' +
          submissionToDelete.user.name +
          ' submission? This action is irreversible!'
        "
      />
    </div>
    <!-- Confirmation modal for hiding submission -->
     <pl-dialog
      v-if="show_hide_submission_modal"
      size="relative_sm"
      title="Hide Submission"
      @close="show_hide_submission_modal = false"
      :disableOutsideClick="true"
    >
      <div class="h-full w-full overflow-y-auto">
        <div class="flex flex-col h-full space-y-4">
          <div class="overflow-y-auto h-full px-5">
            <div class="bg-gray-50 border border-gray-200 p-4 rounded-lg text-gray-800 font-manrope space-y-3">
              <p class="text-sm">
               This will hide this student's submission and associated comments from Roundtable participants. Only you and the original poster can see it from now on.
              </p>
              <div class="flex justify-between items-center">
                <div class="flex items-center space-x-3">
                  <img  class="w-8 h-8 rounded-full"  :src="submissionToHide.user.avatar_url" :alt="submissionToHide.user.name" />
                  <span class="font-semibold text-gray-900 line-through">
                    {{ submissionToHide.user.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-shrink-0 px-5 pb-3.5 flex space-x-2 font-manrope">
            <button
              @click="show_hide_submission_modal = false"
              class="flex-1 bg-white hover:bg-gray-100 transition-colors py-2 flex items-center justify-center space-x-2 text-gray-800 rounded-lg"
            >
              Cancel
            </button>
            <button
              @click="handleHideSubmission(true)"
              class="flex-1 bg-primary hover:bg-primary-dark transition-colors py-2 flex items-center justify-center space-x-2 text-white font-semibold rounded-lg"
            >
              <span>{{ isExecuting === true ? 'Hiding...' : 'Confirm'}}</span>
              <div v-if="isExecuting === true" class="loader"></div>
            </button>
          </div>
        </div>
      </div>
    </pl-dialog>
    <!-- Delete Comment -->
    <dialog-delete-confirm
      v-if="show_delete_comment_dialog"
      @close="show_delete_comment_dialog = false"
      @actionConfirmed="deleteComment"
      optionalText="Delete Comment"
      :subHeader="'Are you sure you want to delete this comment? This action is irreversible!'"
    />
    <!-- Comment Hiding Dialog -->
    <pl-confirm
      :typeConfirm="false"
      message="Hide Comment"
      confirmText="HIDE"
      class="tl"
      v-if="show_hide_comment_modal"
      @confirm="hideComment(true)"
      @close="show_hide_comment_modal = false"
    >
      <div class="px-7 flex-grow overflow-y-auto">
        <div class="flex justify-center mt-9 mb-3">
          <i
            class="fa-solid fa-triangle-exclamation text-yellow-400 text-3xl"
          ></i>
        </div>
        <div>
          <p class="text-center text-gray-700 mb-2">
            This will hide the comment and associated comments from participants
            in the RoundTable. Only you and the original poster can see it from
            now on.
          </p>
        </div>
      </div>
    </pl-confirm>
    <!-- FLag Dialog -->
    <pl-confirm
      :typeConfirm="false"
      message="Inappropriate Comment"
      confirmText="This is inappropriate!"
      confirmColor="bg-red-500 hover:bg-red-600 text-white"
      class="tl"
      v-if="show_flag_dialog"
      @confirm="closeDialog('confirm-flag', 'flag')"
      @close="show_flag_dialog = false"
    >
      <div class="flex justify-center mt-10 mb-5">
        <i class="fa-solid fa-comment-slash text-red-500 text-3xl"></i>
      </div>
      <div class="px-24 mb-6">
        <p class="text-center text-gray-700 mb-2">
          Are you sure you want to mark
          <span class="font-bold">this comment</span> as inappropriate? Use this
          action if you <span class="font-bold">feel uncomfortable</span> with
          the comment!
        </p>
      </div>
    </pl-confirm>
    <!-- View Criteria -->
    <pl-dialog
      v-if="show_assessment_modal"
      @close="show_assessment_modal = false"
      maxHeight="80%"
      width="80%"
      max-width="700px"
    >
      <div
        v-if="Number(getCurrentRT.point_cap) > 0"
        class="pl-subheading start-xs"
        style="padding: 10px 30px"
      >
        Max Score: {{ Number(getCurrentRT.point_cap) }}
      </div>
      <div class="row no-margin start-xs scroll" style="padding: 10px 20px">
        <div
          class="col-xs-6 start-xs"
          style="padding: 10px"
          v-for="point in getCurrentRT.points_settings.peer_rewards"
          :key="point.tag"
        >
          <span class="pl-title">
            {{ point.title }}
          </span>
          <div class="pl-body-2 row no-margin start-xs middle-xs">
            <p>
              {{
                typeof point.description === 'object'
                  ? point.description.join('. ')
                  : point.description
              }}
            </p>
          </div>
        </div>
      </div>
    </pl-dialog>
    <dialog-delete-confirm
      v-if="show_confirm_delete_feedback"
      @close="cancelDeleteSavedFeedback"
      @actionConfirmed="confirmDeleteSavedFeedback"
      :header="'Delete this saved feedback template'"
      :subHeader="'It will be permanently removed from this course.'"
    />
    <NewFeedbackTemplateModal
      v-if="show_saved_feedback_modal"
      @close="closeNewFeedbackModal"
      typeRoundtable="online"
      :feedbackID="feedback_id"
      :feedbackContent="feedback_content"
      :editingFeedback="set_edit_saved_feedback"
    />
    <ImportFeedbackTemplatesModal
      v-if="show_import_feedback_modal"
      @close="closeImportFeedbackTemplatesModal"
      typeRoundtable="online"
    />
    <create-new-point-modal
      :activityType="activityType"
      :tag="selected_point_tag"
      :rts="roundtables_with_point"
      v-if="show_point_creation_modal"
      @close="show_point_creation_modal = false"
    />
    <anonymous-character-description-modal
      :anonymous_identity="identity_to_show"
      @close="show_anonymous_description_modal = false"
      v-if="show_anonymous_description_modal"
    />
    <dialog-delete-confirm
      v-if="show_delete_point_modal"
      @close="show_delete_point_modal = false"
      @actionConfirmed="deleteAssessmentPoint"
      optionalText="Are you sure you want to delete this Point?"
    />
    <template v-if="show_alert_assessment_changing">
      <pl-dialog :maxWidth="'600px'" :padding="'2em'" class="center-xs">
        <div style="position: absolute; right: 0; top: 0">
          <pl-button
            @click.native="closeAssessmentChangingAlert"
            style="min-width: 0"
          >
            <strong class="f4">X</strong>
          </pl-button>
        </div>
        <div class="header pv3">
          <span class="pl-secondary b" style="font-size: 24px">Heads up!</span>
        </div>
        <div class="ph3" style="text-align: justify">
          <p>
            Changing (or deleting) this assessment criteria for this RoundTable
            will change (or delete) it for all of the other RoundTables in this
            course that also use this criteria:
          </p>
          <ul>
            <li
              class="b"
              v-for="roundtable in displayCriteriaRts"
              :key="roundtable.id"
            >
              {{ roundtable.title }}
            </li>
          </ul>
        </div>
        <div class="pv2">
          <pl-button
            class="pl-primary"
            style="font-size: 16px"
            @click.native="closeAssessmentChangingAlert"
          >
            Okay, Got it.
          </pl-button>
        </div>
      </pl-dialog>
    </template>
    <!-- View Unsubmitted -->
    <pl-dialog v-if="show_unsubmitted_modal" height="80%" maxWidth="630px">
      <pl-button
        @click.native="show_unsubmitted_modal = false"
        style="position: absolute; top: 12px; right: 12px; margin: 0"
        class="pl-icon"
      >
        <i class="fa fa-close fa-lg"></i>
      </pl-button>
      <div class="flex">
        <div class="avatar-circle avatar-size ml3">
          <img :src="unsubmitted_response.user.avatar_url" alt="avatar" />
        </div>
        <div class="tl ml3">
          <p class="ma0 pl-title">{{ unsubmitted_response.user.name }}</p>
          <div><p class="ma0 ruby-text i">Unsubmitted</p></div>
        </div>
      </div>
      <div>
        <div class="unsubmitted-text-section">
          <section
            class="prompt-response ph3 tl"
            style="font-weight: 500"
            v-html="unsubmitted_response.draft_response"
          />
        </div>
        <div class="i pl3 tl mt4" style="font-size: 12px; color: #273248">
          {{ unsubmitted_response.word_count }} Words
        </div>
      </div>
    </pl-dialog>
    <DialogDeleteConfirm
      v-if="delete_recap"
      @close="delete_recap = false"
      @action="deleteGenieRecap()"
      :title="delete_recap_information.title"
      :content="delete_recap_information.description"
      :processing="is_processing_action"
    />
    <EditGenieRecapModal
      v-if="edit_recap"
      :genieRecap="genieRecap"
      @close="edit_recap = false"
    />
  </div>
</template>

<!-- JS -->
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import { DeleteRecap } from '../../../components/Dialogs/TypesDeleteConfirm.js';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import store from 'store';
  import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import AnonymousCharacterDescriptionModal from 'components/modals/anonymousCharacterDescriptionModal';
  import createNewPointModal from 'components/createNewPointModal.vue';
  import SavedFeedbackModal from 'components/modals/savedFeedbackModal';
  import onlineRoundtableSockets from 'mixins/sockets/onlineRoundtableSocketEvents';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';
  import Checklist from 'components/checklist.vue';
  import GenieRecap from '../components/genieRecap/genieRecap.vue';
  import EditGenieRecapModal from 'components/modals/editGenieRecapModal.vue';

  export default Vue.extend({
    data() {
      return {
        edit_prompt: false,
        isExecuting: false,
        sortSubmissionsBy: 'random',
        opened_submissions: {},
        entry: {},
        identity_to_show: {},
        show_delete_submission_modal: false,
        show_hide_submission_modal: false,
        show_delete_comment_dialog: false,
        show_hide_comment_modal: false,
        show_import_feedback_modal: false,
        show_saved_feedback_modal: false,
        show_flag_dialog: false,
        show_anonymous_description_modal: false,
        show_assessment_modal: false,
        show_point_creation_modal: false,
        activityType: null,
        type: null,
        submissionToDelete: {},
        submissionToHide: null,
        confirm: '',
        error_message: '',
        toast_msg: '',
        label_confirm_msg: 'Type "confirm" into the field to continue',
        feedback_content: '',
        feedback_id: '',
        set_edit_saved_feedback: false,
        show_confirm_delete_feedback: false,
        show_unsubmitted_modal: false,
        unsubmitted_response: {},
        selected_point_tag: null,
        show_delete_point_modal: false,
        delete_point_index: null,
        roundtables_with_point: [],
        show_alert_assessment_changing: false,
        is_in_viewport: false,
        in_viewport: [],
        selectedSubmission: null,
        submissionToClose: null,
        feedback_to_delete: {},
        edit_recap: false,
        delete_recap: false,
        delete_recap_information: DeleteRecap,
        is_processing_action: false,
        sorted_submissions_list: [],
      };
    },
    components: {
      SubmissionCard: () =>
        import('../components/submissionCard/submissionCard'),
      ByPassCard: () => import('../components/byPassCard.vue'),
      dialogDeleteConfirm,
      AnonymousCharacterDescriptionModal,
      createNewPointModal,
      SavedFeedbackModal,
      ImportFeedbackTemplatesModal: () =>
        import('components/modals/ImportFeedbackModal.vue'),
      NewFeedbackTemplateModal: () =>
        import('components/modals/NewFeedbackModal.vue'),
      Checklist,
      GenieRecap,
      EditGenieRecapModal,
      DialogDeleteConfirm: () =>
        import('../../../components/Dialogs/DialogConfirmDelete.vue'),
    },
    watch: {
      // '$route.query'() {
      //   const { submissionId, tab } = this.$route.query;
      //   if (submissionId && tab) {
      //     this.scrollToSubmission(submissionId);
      //   }
      // },
      show_delete_point_modal() {
        if (this.show_delete_point_modal === false) {
          this.delete_point_index = null;
          this.roundtables_with_point = [];
          this.selected_point_tag = null;
        }
      },
      show_point_creation_modal() {
        if (this.show_point_creation_modal === false) {
          this.roundtables_with_point = [];
          this.selected_point_tag = null;
        }
      },
    },
    mixins: [onlineRoundtableSockets, courseSocketMixin],
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getSubmissionsBySubmitStatus',
        'getProfile',
        'getCurrentRT',
        'getCourseDetail',
        'getMyRTUserDetails',
      ]),
      currentSubmission: function () {
        const current_submission = this.getCurrentRT.submissions.find(
          (s) => s.id === this.getMyRTUserDetails.submission_id
        );
        return current_submission;
      },
      submittedSubmissionList() {
        let all_submissions = [];
        let student_submissions = [];
        if (
          this.submittedSubmissionStudents &&
          this.submittedSubmissionStudents.length
        ) {
          this.submittedSubmissionStudents.forEach((item) => {
            let lastName = item.user.name.split(' ').slice(-1).join(' ');
            item.user.lastName = lastName;
            if (!this.ownSubmission(item.id)) {
              if (
                (!item.is_hidden && !item.is_model_response) ||
                (item.is_hidden &&
                  !item.is_model_response &&
                  this.hasTeacherPermissionsInCourse)
              ) {
                student_submissions.push(item);
              }
            }
          });
        }
        if (
          !this.hasTeacherPermissionsInCourse &&
          this.byPassSubmissionList &&
          this.byPassSubmissionList.length
        ) {
          all_submissions = student_submissions.concat(
            this.byPassSubmissionList
          );
          return all_submissions;
        }
        all_submissions = student_submissions;
        return all_submissions;
      },
      submittedSubmissionLists() {
        let all_submissions = [];
        let student_submissions = [];
        if (
          this.submittedSubmissionStudents &&
          this.submittedSubmissionStudents.length
        ) {
          this.submittedSubmissionStudents.forEach((item) => {
            let lastName = item.user.name.split(' ').slice(-1).join(' ');
            item.user.lastName = lastName;
            if (!this.ownSubmission(item.id)) {
              if (
                (!item.is_hidden && !item.is_model_response) ||
                (item.is_hidden &&
                  !item.is_model_response &&
                  this.hasTeacherPermissionsInCourse)
              ) {
                student_submissions.push(item);
              }
            }
          });
        }
        if (
          !this.hasTeacherPermissionsInCourse &&
          this.byPassSubmissionList &&
          this.byPassSubmissionList.length
        ) {
          all_submissions = student_submissions.concat(
            this.byPassSubmissionList
          );
          return all_submissions;
        }
        all_submissions = student_submissions;
        return all_submissions;
      },
      submittedSubmissionStudents() {
        let all_submissions = [];
        let student_submissions = [];
        if (this.hasTeacherPermissionsInCourse) {
          student_submissions =
            this.getSubmissionsBySubmitStatus.submitted.filter(
              (student) => !student.teacher_submission
            );
          if (this.byPassSubmissionList && this.byPassSubmissionList.length) {
            all_submissions = student_submissions.concat(
              this.byPassSubmissionList
            );
            return all_submissions;
          }
        } else {
          student_submissions =
            this.getSubmissionsBySubmitStatus.submitted.filter((student) =>
              this.getProfile.my_rt_user_details.submission_id === student.id
                ? !student.teacher_submission
                : !student.teacher_submission && student.is_hidden === false
            );
          if (this.byPassSubmissionList && this.byPassSubmissionList.length) {
            all_submissions = student_submissions.concat(
              this.byPassSubmissionList
            );
            return all_submissions;
          }
        }
        all_submissions = student_submissions;
        return all_submissions;
      },
      submittedSubmissionTeacher() {
        if (this.hasTeacherPermissionsInCourse) {
          return this.getSubmissionsBySubmitStatus.submitted.filter(
            (teacher) => teacher.teacher_submission
          );
        } else {
          return this.getSubmissionsBySubmitStatus.submitted.filter(
            (teacher) => teacher.teacher_submission && !teacher.is_hidden
          );
        }
      },
      submittedOwnSubmissionStudent() {
        let student_submission = [];
        if (!this.hasTeacherPermissionsInCourse) {
          student_submission =
            this.getSubmissionsBySubmitStatus.submitted.filter(
              (student) =>
                this.getProfile.my_rt_user_details.submission_id ===
                  student.id && !student.teacher_submission
            );
        }
        return student_submission;
      },
      submittedModelSubmissions() {
        if (this.hasTeacherPermissionsInCourse) {
          return this.getSubmissionsBySubmitStatus.submitted.filter(
            (s) => s.is_model_response && !s.teacher_submission
          );
        } else {
          return this.getSubmissionsBySubmitStatus.submitted.filter(
            (s) =>
              s.is_model_response &&
              !this.ownSubmission(s.id) &&
              !s.is_hidden &&
              !s.teacher_submission
          );
        }
      },
      byPassSubmissionList() {
        return this.getSubmissionsBySubmitStatus.by_passed;
      },
      displayCriteriaRts() {
        return this.roundtables_with_point.filter(
          (x) => x.id !== this.getCurrentRT.id
        );
      },
      orderedSubmissions() {
        let sorted_list = [];
        switch (this.sortSubmissionsBy) {
          case 'random':
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionLists
            );
            return sorted_list;
          case 'date-asc':
            this.submittedSubmissionList.sort((a, b) => {
              if (a.start_date && b.start_date) {
                return new Date(a.start_date) - new Date(b.start_date);
              }
            });
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionList
            );
            return sorted_list;
          case 'date-desc':
            this.submittedSubmissionList.sort((a, b) => {
              if (a.start_date && b.start_date) {
                return new Date(b.start_date) - new Date(a.start_date);
              }
            });
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionList
            );
            return sorted_list;
          case 'student-desc':
            this.submittedSubmissionList.sort((a, b) => {
              if (a.start_date && b.start_date) {
                return a.user.name.localeCompare(b.user.name);
              }
            });
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionList
            );
            return sorted_list;
          case 'student-asc':
            this.submittedSubmissionList.sort((a, b) => {
              if (a.start_date && b.start_date) {
                return b.user.name.localeCompare(a.user.name);
              }
            });
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionList
            );
            return sorted_list;
          case 'last-name-desc':
            this.submittedSubmissionList.sort((a, b) => {
              if (a.start_date && b.start_date)
                return a.user.lastName.localeCompare(b.user.lastName);
            });
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionList
            );
            return sorted_list;
          case 'last-name-asc':
            this.submittedSubmissionList.sort((a, b) => {
              if (a.start_date && b.start_date)
                return b.user.lastName.localeCompare(a.user.lastName);
            });
            sorted_list = this.submittedSubmissionTeacher.concat(
              this.submittedOwnSubmissionStudent,
              this.submittedModelSubmissions,
              this.submittedSubmissionList
            );
            return sorted_list;
        }
      },
      responses() {
        let array = [];
        this.orderedSubmissions.forEach((s) => {
          if (s.start_date) {
            array.push(s.id);
          }
        });

        // emit to assessments tab submissions without running genie and teacher submissions
        let assessments_tab_array = [];
        this.orderedSubmissions.forEach((s) => {
          if (
            s.start_date &&
            !s.is_genie_assessment_run &&
            !s.teacher_submission
          ) {
            assessments_tab_array.push(s.id);
          }
        });
        this.$emit('orderedSubmissions', assessments_tab_array);

        return array;
      },
      studentsInvited() {
        return (
          (this.getSubmissionsBySubmitStatus.not_submitted.length ||
            this.getSubmissionsBySubmitStatus.submitted.length ||
            this.getSubmissionsBySubmitStatus.by_passed.length) !== 0
        );
      },
      genieRecap() {
        return this.getCurrentRT.genie_recap;
      },
      submissionsCount() {
        return this.orderedSubmissions.filter(
          (submission) =>
            submission.prompt_response !== null &&
            submission.is_hidden === false
        ).length;
      },
    },
    methods: {
      nextUnopenedSubmissionID(submissionID, array) {
        return this.nextSubmissionId(submissionID, array);
      },
      nextSubmissionId(submissionID, array) {
        for (let index = 0; index <= array.length - 1; index += 1) {
          if (!this.opened_submissions[array[index]]) {
            return array[index];
          }
        }
        return array[0];
      },
      ownSubmission(id) {
        return this.getProfile.my_rt_user_details.submission_id === id;
      },
      async scrollToSubmission(submissionId) {
        if (submissionId === '') return;
        await this.$store.dispatch('submissionClicked', submissionId);
        setTimeout(() => {
          // const nodeList = document.querySelectorAll(`#feed-${submissionId}`);
          // let submissionToScrollToElement;
          // if (nodeList.length === 1) {
          //   [submissionToScrollToElement] = nodeList;
          // } else {
          //   submissionToScrollToElement = Array.from(nodeList).find(
          //     (node) =>
          //       node.parentElement
          //         .closest('.vue-recycle-scroller__item-view')
          //         .style.transform.split('translateY(')[1]
          //         .split('px)')[0] >= 0
          //   );
          // }
          let submissionToScrollToElement = document.getElementById(
            `feed-${submissionId}`
          );
          if (submissionToScrollToElement) {
            submissionToScrollToElement.scrollIntoView({
              block: 'start',
              inline: 'nearest',
              behavior: 'smooth',
            });
          }
        }, 0);
      },
      openAssessmentTab(submission_id, openFrom) {
        if (openFrom === false) {
          return;
        } else {
          this.$emit('openAssessmentTab');
          // const scroller = this.$refs.scroller;
          // if (scroller) {
          //   const nodeList = document.querySelectorAll(
          //     `#submission-tab-row-${submission_id}`
          //   );
          //   let submissionToScrollToElement;
          //   if (nodeList.length === 1) {
          //     [submissionToScrollToElement] = nodeList;
          //   } else {
          //     submissionToScrollToElement = Array.from(nodeList).find(
          //       (node) =>
          //         node.parentElement
          //           .closest('.vue-recycle-scroller__item-view')
          //           .style.transform.split('translateY(')[1]
          //           .split('px)')[0] >= 0
          //     );
          //   }
          //   if (submissionToScrollToElement) {
          //     submissionToScrollToElement.scrollIntoView({
          //       block: 'start',
          //       inline: 'nearest',
          //       behavior: 'smooth',
          //     });
          //   }
          // }
          /* if (this.getProfile.role === 'teacher') {
            this.$emit('openAssessmentTab');
          }
          if(this.getP) */
          
        }
      },
      showDeleteSubmissionModal(submission) {
        this.submissionToDelete = submission;
        this.show_delete_submission_modal = true;
      },
      deleteSubmission() {
        this.$store
          .dispatch('deleteSubmission', this.submissionToDelete.id)
          .then(() => {
            if (this.submissionToDelete.is_model_response) {
              this.$store
                .dispatch('toggleModelResponse', this.submissionToDelete.id)
                .catch(console.error);
            }
            this.submissionToDelete = null;
          });
      },
      showHideSubmissionModal(submission) {
        if (submission.is_hidden) {
          this.submissionToHide = submission;
          this.handleHideSubmission(false, this.submissionToHide);
        } else {
          this.show_hide_submission_modal = true;
          this.submissionToHide = submission;
        }
      },
      handleHideSubmission: async function(hide = true) {
        try {
          const payload = {
            payload: { is_hidden: hide },
            submission_id: this.submissionToHide.id,
          };
          this.isExecuting = true;
          await this.$store.dispatch('toggleHideSubmission', payload);
          this.submissionToHide = null;
          this.show_hide_submission_modal = false;
          this.isExecuting = false;
          EventBus.$emit('createToast', {type: 'Success', message: `You've ${hide === true ? 'hidden' : 'reveal'} this submission`, time: 5000 });
        } catch (error) {
          this.isExecuting = false;
          EventBus.$emit('createToast', {type: 'Error', message: `Something happended ${hide === true ? 'hidden' : 'reveal'} this submission! Please try again`, time: 5000 });
          console.error('Error in handleHideSubmission:', error);
        }
      },
      openAnonymityModal(anonymous_identity) {
        this.show_anonymous_description_modal = true;
        this.identity_to_show = anonymous_identity;
      },
      goToStudentSubmissionPage() {
        this.$router.push({
          name: 'roundtable.submit',
          params: this.$route.params,
        });
      },
      cancelDelete() {
        this.show_delete_comment_dialog = false;
        this.error_message = '';
      },
      closeDialog(ref, action) {
        // finish flagging
        if (action === 'flag') {
          this.flagToggle(this.entry.id);
          this.show_flag_dialog = false;
          return;
        }
        if (action === 'delete-comment' && this.confirm === 'confirm') {
          this.confirm = '';

          roundtableService
            .deleteComment(this.entry.id)
            .then(() => {
              //EventBus.$emit('toast-msg', 'Comment successfully deleted');
              const toast = {
                type: 'Success',
                message: 'Comment successfully deleted',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);

              store.dispatch('updateComment', {
                delete: true,
                id: this.entry.id, // comment to delete
                comment_id: this.entry.comment_id, // if comment is a reply, will have comment_id
                submission_id: this.entry.submission_id,
              });
              this.show_delete_comment_dialog = false;
            })
            .then(() => {
              store.dispatch('deleteComment', this.entry);
              this.entry.is_model_submission
                ? this.$store.dispatch(
                    'toggleModelResponse',
                    this.entry.submission_id
                  )
                : null;
            })
            .catch(console.error);
        }
        // set error msg with confirm is not filled
        if (action === 'delete-comment' && this.confirm !== 'confirm') {
          this.confirm = '';
          this.error_message =
            'Please type "confirm" in the input box to continue';
          return;
        }
        this.confirm = '';
      },
      deleteComment() {
        roundtableService
          .deleteComment(this.entry.id)
          .then(() => {
            //EventBus.$emit('toast-msg', 'Comment successfully deleted');
            const toast = {
              type: 'Success',
              message: 'Comment successfully deleted',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);

            store.dispatch('updateComment', {
              delete: true,
              id: this.entry.id, // comment to delete
              comment_id: this.entry.comment_id, // if comment is a reply, will have comment_id
              submission_id: this.entry.submission_id,
            });
            this.show_delete_comment_dialog = false;
          })
          .then(() => {
            store.dispatch('deleteComment', this.entry);
            this.entry.is_model_submission
              ? this.$store.dispatch(
                  'toggleModelResponse',
                  this.entry.submission_id
                )
              : null;
          })
          .catch(console.error);
      },
      flagToggle(entryID) {
        if (this.type === 'comment') {
          roundtableService
            .flagComment(this.getProfile.id, entryID)
            .then((res) => {
              if (res.data.comment_id === null) {
                store.dispatch('updateCommentFlag', res.data);
              } else {
                store.dispatch('updateReplyFlag', res.data);
              }
              const flagged = res.data.flagged_by.includes(this.getProfile.id);
              const toast_msg = flagged
                ? 'Flag successful! Your teacher will be notified.'
                : 'Unflag successful!';
              EventBus.$emit('toast-msg', toast_msg);
            })
            .catch((err) => {
              const msg =
                err.response.data.message ||
                'Something went wrong, please try again.';
              EventBus.$emit('toast-msg', msg);
            });
        } else if (this.type === 'submission') {
          roundtableService.flagSubmission(this.getProfile.id, entryID);
        }
        this.type = null;
      },
      handleCommentClick() {
        if (this.entry.is_hidden) {
          this.hideComment(false);
        } else {
          this.show_hide_comment_modal = true;
        }
      },
      hideComment(hide = true) {
        this.$store.dispatch('toggleHideComment', {
          payload: {
            is_hidden: hide,
          },
          comment_id: this.entry.id,
        });
        this.show_hide_comment_modal = false;
      },
      showAssessmentModal() {
        this.show_assessment_modal = true;
      },
      cancelDeleteSavedFeedback() {
        this.show_confirm_delete_feedback = false;
        EventBus.$emit('showTemplateModal');
      },
      confirmDeleteSavedFeedback() {
        this.$store
          .dispatch('deleteFeedback', {
            course_id: this.getCourseDetail.id,
            feedback_id: this.feedback_to_delete.id,
            onlineRT: true,
          })
          .then(() => {
            this.feedback_to_delete = {};
            this.show_confirm_delete_feedback = false;
            EventBus.$emit('showTemplateModal');
          });
      },
      closeNewFeedbackModal: function () {
        this.show_saved_feedback_modal = false;
        this.set_edit_saved_feedback = false;
        this.feedback_id = '';
        this.feedback_content = '';
        EventBus.$emit('showTemplateModal');
      },
      closeImportFeedbackTemplatesModal() {
        this.show_import_feedback_modal = false;
        EventBus.$emit('showTemplateModal');
      },
      async deleteAssessmentPoint() {
        let clonedCoursePointSettings =
          this.getCourseDetail.points_settings.peer_rewards.slice();
        clonedCoursePointSettings.splice(this.delete_point_index, 1);
        let payload = [];
        if (this.roundtables_with_point.length) {
          for (let i = 0; i < this.roundtables_with_point.length; i += 1) {
            const rt = this.getCourseDetail.roundtables.find(
              (r) => r.id === this.roundtables_with_point[i].id
            );
            const index_rt = rt.points_settings.peer_rewards.findIndex(
              (x) => x.tag === this.selected_point_tag
            );
            const peer_rewards = rt.points_settings.peer_rewards.slice();
            peer_rewards.splice(index_rt, 1);
            payload.push({ id: rt.id, peer_rewards });
          }
        }
        if (payload.length) {
          await this.$store.dispatch('updateRTsCriteria', {
            id: this.getCourseDetail.id,
            criterias: payload,
            activityType: 'written',
          });
          const currentRTChanged = payload.find(
            (x) => x.id === this.getCurrentRT.id
          );
          if (currentRTChanged) {
            const { peer_rewards } = currentRTChanged;
            const cloned_rt = Object.assign({}, this.getCurrentRT);
            cloned_rt.points_settings = { peer_rewards };
            this.$store.commit('UPDATE_RT_DETAILS', cloned_rt);
          }
        }
        this.$store
          .dispatch('updateCourseDetail', {
            id: this.getCourseDetail.id,
            points_settings: { peer_rewards: clonedCoursePointSettings },
          })
          .then(() => {
            this.show_delete_point_modal = false;
            EventBus.$emit(
              'toast-msg',
              'Assessment Criteria Point has been deleted.'
            );
          });
      },
      checkRoundtablesWithPoint(tag) {
        this.selected_point_tag = tag;
        const { roundtables } = this.getCourseDetail;
        let result = [];
        for (let index = 0; index < roundtables.length; index += 1) {
          const rt = roundtables[index];
          const { peer_rewards } = rt.points_settings;
          const has_point = peer_rewards.find(
            (p) => p.tag === this.selected_point_tag
          );
          if (has_point) {
            result.push({ title: rt.title, id: rt.id });
          }
        }
        this.roundtables_with_point = result;
        const only_current_roundtable =
          this.roundtables_with_point.length === 1
            ? this.roundtables_with_point[0].id === this.getCurrentRT.id
            : false;
        if (this.roundtables_with_point.length && !only_current_roundtable) {
          this.show_alert_assessment_changing = true;
        }
        return result;
      },
      closeAssessmentChangingAlert() {
        this.show_alert_assessment_changing = false;
        if (this.delete_point_index) {
          this.show_delete_point_modal = true;
        } else {
          this.show_point_creation_modal = true;
        }
      },
      deleteGenieRecap() {
        this.is_processing_action = true;
        this.$store
          .dispatch('deleteGenieRecap', {
            id: this.genieRecap.id,
            roundtable_id: this.getCurrentRT.id,
          })
          .then(() => {
            const toast = {
              type: 'Success',
              message: 'Genie Recap successfully deleted.',
              time: 5000,
            };
            this.is_processing_action = false;
            this.delete_recap = false;
            EventBus.$emit('createToast', toast);
            EventBus.$emit('sidebar-recap', false);
          })
          .catch((err) => {
            console.error(err);
            const toast = {
              type: 'Error',
              message:
                'Sorry! Something wrong happenned on deleting Genie Recap.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          });
      },
    },
    created() {
      const subsIDs = this.orderedSubmissions.map((s) => s.id);
      subsIDs.forEach((subID) => {
        this.opened_submissions[subID] = false;
      });
    },
    beforeRouteLeave: async function (to, from) {
      if (to.params.roundtableID !== from.params.roundtableID) {
        this.leaveCourseSocket(from.params.courseID);
      }
    },
    mounted() {
      const { courseID, roundtableID } = this.$route.params;
      this.setupCourseSocket(courseID);
      this.leaveRoundtableSocket(roundtableID);
      this.setupRoundtableSocket(roundtableID);

      this.$nextTick(() => {
        EventBus.$emit('feed-is-mounted');
      });

      const focus_tinymce = () => {
        setTimeout(() => {
          const editor = window.tinymce.get('editor');
          if (editor) {
            editor.execCommand('mceFocus', true, 'editor');
          } else {
            focus_tinymce();
          }
        }, 1000);
      };
      if (
        this.$route.query.user_created &&
        this.hasTeacherPermissionsInCourse
      ) {
        this.edit_prompt = true;
        focus_tinymce();
      }
      EventBus.$on('sort-submissions', (event) => {
        this.sortSubmissionsBy = event;
      });

      EventBus.$on('scrollToSubmission', (submissionId) => {
        this.scrollToSubmission(submissionId);
      });

      EventBus.$on('deleteComment', (type, entry) => {
        this.entry = entry;
        type === 'comment' ? (this.show_delete_comment_dialog = true) : null;
      });

      EventBus.$on('handleComment', (entry) => {
        this.entry = entry;
        this.handleCommentClick();
      });

      EventBus.$on('flagToggle', (entry, type, value) => {
        this.show_flag_dialog = value;
        this.entry = entry;
        this.type = type;
      });

      EventBus.$on('showPointCreationModal', (value, tag) => {
        this.activityType = value;
        if (tag) {
          this.checkRoundtablesWithPoint(tag);
          this.selected_point_tag = tag;
        }
        if (!this.show_alert_assessment_changing) {
          this.show_point_creation_modal = true;
        }
      });
      EventBus.$on('newSavedFeedback', () => {
        this.show_saved_feedback_modal = true;
      });
      EventBus.$on('showImportFeedback', () => {
        this.show_import_feedback_modal = true;
      });
      EventBus.$on('editSavedFeedback', (value) => {
        this.feedback_id = value.feedback_id;
        this.feedback_content = value.feedback_content;
        this.show_saved_feedback_modal = true;
        this.set_edit_saved_feedback = true;
      });

      EventBus.$on('deleteSavedFeedback', (value) => {
        this.feedback_to_delete = value;
        this.show_confirm_delete_feedback = true;
      });

      EventBus.$on('showUnsubmitted', (submission) => {
        this.show_unsubmitted_modal = true;
        this.unsubmitted_response = submission;
      });
      EventBus.$on('delete-assessment-point', (tag) => {
        this.delete_point_index =
          this.getCourseDetail.points_settings.peer_rewards.findIndex(
            (x) => x.tag == tag
          );
        this.checkRoundtablesWithPoint(tag);
        if (!this.show_alert_assessment_changing) {
          this.show_delete_point_modal = true;
        }
      });
    },
    beforeDestroy() {
      EventBus.$off('scrollToSubmission');
      EventBus.$off('goToStudentSubmissionPage');
      EventBus.$off('deleteComment');
      EventBus.$off('handleComment');
      EventBus.$off('flagToggle');
      EventBus.$off('editSavedFeedback');
      EventBus.$off('deleteSavedFeedback');
      EventBus.$off('showUnsubmitted');
      EventBus.$off('showPointCreationModal');
      EventBus.$off('delete-assessment-point');
      EventBus.$off('sort-submissions');
      EventBus.$off('showImportFeedback');
      EventBus.$off('newSavedFeedback');
      this.leaveRoundtableSocket(this.$route.params.roundtableID);
    },
  });
</script>

<!-- CSS -->
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .main-container
    position: relative;
    height: 100%

  .re-center-roundtable-feed-component {
    padding-right: 260px;
    position: inherit;
    height: 100%;
    @media (max-width: 1450px) {
      padding-right: 0px;
    }
  }
  .feed-component {
    .edit-roundtable-button {
      color: pl-charcoal;
      font-size: 12px;
      margin: none;
    }
  }

  .feed-card
    background: #fff
    width: 100%

  .observer
    width: 100%

  .feed-title {
    color: #808284
    margin: 10px
  }
  .feed-divider {
    max-width: 680px
    width: 100%
    height: 50px
    margin: 1em auto
  }
  .loading-comments-screen {
    font-size: 30px
    position: fixed
    z-index: 1
    top: 50%
  }
  .no-responses-message {
    border: 2px solid #e6e7e7
    padding: 30px 0 30px 0
    max-width: 680px
    margin: 1em auto
    font-weight: 400
  }
  .scroller
    height: 100%;

  .transparent-modal
    left: 0
    top: 0
    display: block
    position: fixed
    z-index: 998
    width: 100%
    height: 100%
    overflow-y: hidden
    background: rgba(0,0,0,0.2)

  .scroll
    height: calc(100vh - 250px)
    overflow: auto

  .ruby-text
    color: pl-ruby

  .avatar-size
    width: 40px
    height: 40px
    img
      height: 100%

  .avatar-circle
    border-radius: 50%
    background-color: pl-fog
    border: 1px solid alpha(pl-slate, 0.3)

  .unsubmitted-text-section
    height:calc(80vh - 130px)
    overflow-y: scroll

  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }

  .checklist-height
    height:calc(100vh - 160px)
</style>



// WEBPACK FOOTER //
// discussionTab.vue?0507786b